import { useState } from "react";
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress";
import { handleSnackBar, invokeGetService, invokePostService } from "../../../store/global/actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import Alert from '@material-ui/lab/Alert/Alert';

let options = {
    form_name_root: "probability_table",
    show_errors: "never",
    disable_collapse: true,
    disable_edit_json: true,
    disable_properties: true,
    remove_button_labels: true,
    input_width: '100px',
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
    disable_array_add: true // For hiding + button
}

export default function ProbabilityTable({id, onClose}) {
    const dispatch = useDispatch();

    const [isFetching, setFetching] = useState(false);
    const [schemaValues, setSchemaValues] = useState({testcases: [{testcase: ''}]})
    const [formData, setFormData] = useState(null);
    const [isUpdating, setUpdating] = useState(false)


    const schema = {
        type: "object",
        no_additional_properties: true,
        properties: {
            testcases: {
                type: "array",
                format: "table",
                items: {
                    type: "object",
                    title: "Testcases",
                    properties: {
                        id: {
                            type: "string",
                            readonly: true,
                            title: '',
                            format: 'hidden'
                        },
                        testcase: {
                            type: "string",
                            readonly: true,
                            title: "Testcase",
                        },
                        probability: {
                            type: "string",
                            title: "Probability",
                            default: "",
                            options: {
                                hidden: false
                            }
                        }
                    }
                }
            }
        },
        options: {
            disable_collapse: true,  // Optional to prevent collapsing sections
            disable_properties: true // Optional to prevent adding new properties
        }
    };

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const onChangeJsonEditor = (data) => {
        if(JSON.stringify(data) !== JSON.stringify(schemaValues)){
            setSchemaValues(data)
        }
    }

    const onProbabilityUpdate = async () => {
        setUpdating(true)
        await dispatch(invokePostService('updateProbability', {data: schemaValues?.testcases, testsuiteId: id})).then((response) => {
            if(response.status){
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
            }
        })
        setUpdating(false)
    }

    const initProbablityData = async () => {
        setFetching(true);
        const testcases = await dispatch(invokeGetService('listTestcases', []));
        const filteredTestcases = testcases?.data?.filter(item => item.testsuite_id === id)?.map(item => ({id: item._id, testcase: item.name, probability: item.probability || 100}));
        setSchemaValues({testcases: filteredTestcases})
        setFetching(false);
    }

    useEffect(() => {
        initProbablityData();
    },[])


    return(
        <div>
            {isFetching ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                : schemaValues?.testcases?.length === 0 ?
                <Grid>
                    <Alert severity="warning">
                        No testcase exists in the testsuite!
                    </Alert>
                </Grid>
                : <>
                    <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="probability_table"/>
                    <Grid xs={12} style={{ justifyContent: 'flex-end', display: 'flex' }}>
                        <UpdateCancel onUpdate={onProbabilityUpdate} onCancel={onClose} updateDisable={isFetching || isUpdating} content={isUpdating ? 'Updating' : 'Update'} />   
                    </Grid> 
                </>
            }
            
        </div>
    )
}